import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";


@Entity('asset_action_control')
export class AssetsActionControl {

    @PrimaryGeneratedColumn("increment", { name: 'asset_action_control_id' })
    assetsActionControlId?: number;

    @Column("varchar", {
        nullable: false,
        length: 20,
        name: "asset_code"
    })
    assetCode: string;
    @Column("varchar", {
        nullable: false,
        length: 20,
        name: "tub_code"
    })
    tubCode: string;

    @Column("varchar", {
        nullable: false,
        name: "cron_job_time",
        length: 20,
    })
    cronJobTime: string;
    @Column("int", {
        nullable: false,
        name: "duration_one",
    })
    durationOne: number;

    @Column("int", {
        nullable: false,
        name: "duration_two",
    })
    durationTwo: number;

    @Column("boolean", {
        nullable: false,
        name: "asset_control",
    })
    assetControl: boolean;

    @Column("boolean", {
        nullable: false,
        name: "tub_status",
    })
    tubStatus: boolean | null;

    @Column("boolean", {
        nullable: false,
        name: "asset_status",
    })
    assetStatus: boolean | null;

    @Column("boolean", {
        nullable: false,
        name: "is_active",
        default: true
    })
    isActive: boolean | null;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    
    @Column("int", {
        nullable: true,
        name: "unit_id",
    })
    unitId:number;

}